<div [class]="containerClasses">
  <div class="floating-select__wrapper">
    @if (label()) {
      <span class="floating-select__label" [id]="selectId + '-label'">
        {{ label() }}
        @if (required()) {
          <span class="floating-select__required" aria-hidden="true"> *</span>
        }
      </span>
    }

    <div
      [id]="selectId"
      class="floating-select__field"
      role="combobox"
      [attr.tabindex]="disabled ? -1 : 0"
      [attr.aria-expanded]="isOpen"
      [attr.aria-controls]="isOpen ? selectId + '-listbox' : null"
      [attr.aria-activedescendant]="activeDescendantId"
      aria-haspopup="listbox"
      [attr.aria-labelledby]="label() ? selectId + '-label' : null"
      [attr.aria-required]="required() ? true : null"
      [attr.aria-invalid]="error() ? true : null"
      [attr.aria-describedby]="errorMessage() ? selectId + '-helper' : null"
      [attr.aria-disabled]="disabled ? true : null"
      (click)="toggleList()"
      (keydown)="onFieldKeyDown($event)"
      (blur)="onFieldBlur($event)"
    >
      @if (displayText) {
        <span class="floating-select__value">{{ displayText }}</span>
      }

      <span class="floating-select__arrow" aria-hidden="true">
        <svg viewBox="0 0 16 16" width="16" height="16" fill="currentColor">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.64592 4.64592C1.69236 4.59935 1.74754 4.56241 1.80828 4.5372C1.86903 4.512 1.93415 4.49902 1.99992 4.49902C2.06568 4.49902 2.13081 4.512 2.19155 4.5372C2.2523 4.56241 2.30747 4.59935 2.35392 4.64592L7.99992 10.2929L13.6459 4.64592C13.6924 4.59943 13.7476 4.56255 13.8083 4.53739C13.8691 4.51223 13.9342 4.49929 13.9999 4.49929C14.0657 4.49929 14.1308 4.51223 14.1915 4.53739C14.2522 4.56255 14.3074 4.59943 14.3539 4.64592C14.4004 4.6924 14.4373 4.74759 14.4624 4.80833C14.4876 4.86907 14.5005 4.93417 14.5005 4.99992C14.5005 5.06566 14.4876 5.13076 14.4624 5.1915C14.4373 5.25224 14.4004 5.30743 14.3539 5.35392L8.35392 11.3539C8.30747 11.4005 8.2523 11.4374 8.19155 11.4626C8.13081 11.4878 8.06568 11.5008 7.99992 11.5008C7.93415 11.5008 7.86903 11.4878 7.80828 11.4626C7.74754 11.4374 7.69236 11.4005 7.64592 11.3539L1.64592 5.35392C1.59935 5.30747 1.56241 5.2523 1.5372 5.19155C1.512 5.13081 1.49902 5.06568 1.49902 4.99992C1.49902 4.93415 1.512 4.86903 1.5372 4.80828C1.56241 4.74754 1.59935 4.69236 1.64592 4.64592Z"
          />
        </svg>
      </span>
    </div>

    @if (isOpen) {
      <div
        class="floating-select__dropdown"
        role="listbox"
        [id]="selectId + '-listbox'"
        [attr.aria-labelledby]="label() ? selectId + '-label' : null"
      >
        @for (option of options(); track option.value) {
          <div
            class="floating-select__option"
            [id]="optionId(option.value)"
            [class.floating-select__option--selected]="isSelected(option.value)"
            [class.floating-select__option--highlighted]="isHighlighted(option.value)"
            [class.floating-select__option--disabled]="option.disabled"
            role="option"
            [attr.aria-selected]="isSelected(option.value)"
            [attr.aria-disabled]="option.disabled ? true : null"
            (mousedown)="selectOption(option, $event)"
          >
            {{ option.label }}
          </div>
        }
      </div>
    }
  </div>

  @if (errorMessage()) {
    <p class="floating-select__helper" [id]="selectId + '-helper'" role="alert">
      {{ errorMessage() }}
    </p>
  }
</div>
